import { Routes } from '@angular/router';

import { adminGuard } from '@core/guards/admin.guard';
import { homeEntryGuard } from '@core/guards/home-entry.guard';
import { PriceCompareComponent } from '@features/analytics/price-compare.component';
import { PriceHistoryComponent } from '@features/analytics/price-history.component';
import { ShoppingHomeComponent } from '@features/shopping/shopping-home.component';
import { StoreListComponent } from '@features/store-list/store-list.component';
import { SimilarProductsComponent } from '@features/analytics/similar-products.component';
import { NamePreviewAdminComponent } from '@features/admin/name-preview-admin/name-preview-admin.component';
import { UnitReviewAdminComponent } from '@features/admin/unit-review-admin/unit-review-admin.component';
import { BasketsManagerComponent } from '@features/baskets/baskets-manager.component';
import { ClassificationAdminComponent } from '@features/admin/classification-admin/classification-admin.component';
import { ClassificationFlowAdminComponent } from '@features/admin/classification-flow-admin/classification-flow-admin.component';
import { ClassifyProbeAdminComponent } from '@features/admin/classify-probe-admin/classify-probe-admin.component';
import { WorkersAdminComponent } from '@features/admin/workers-admin/workers-admin.component';
import { VisitLogAdminComponent } from '@features/admin/visit-log-admin/visit-log-admin.component';
import { PrivacyPolicyComponent } from '@features/legal/privacy-policy.component';
import { TermsOfServiceComponent } from '@features/legal/terms-of-service.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: StoreListComponent, canActivate: [homeEntryGuard] },
  { path: 'store-list', pathMatch: 'full', redirectTo: '' },
  { path: 'shop', component: ShoppingHomeComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms', component: TermsOfServiceComponent },
  { path: 'baskets', component: BasketsManagerComponent },
  { path: 'legacy-compare', component: PriceCompareComponent, canActivate: [adminGuard] },
  { path: 'similar', component: SimilarProductsComponent, canActivate: [adminGuard] },
  { path: 'price-history', component: PriceHistoryComponent, canActivate: [adminGuard] },
  { path: 'admin/unit-reviews', component: UnitReviewAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/name-preview', component: NamePreviewAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/classification', component: ClassificationAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/classification-flow', component: ClassificationFlowAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/classify-probe', component: ClassifyProbeAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/workers', component: WorkersAdminComponent, canActivate: [adminGuard] },
  { path: 'admin/visits', component: VisitLogAdminComponent, canActivate: [adminGuard] },
  { path: '**', redirectTo: '' }
];
